import commonText from "./commonContents";

export default {
  landingPage: {
    welcomeText: "Welcome to Digital SPA!",
    description: "In a few simple steps, you’ll be taken through our Digital SPA process to sign the sales purchase agreement for brand-new Aldar property",
  },
  tabPane: {
    description: "Digital SPA process",
  },
  verification: {
    sectionOne: {
      paragraph:
        "Protecting your identity is important to us, so to make the SPA Journey process as secure as possible we need to verify your ID.",
    },
    idInstruction: {
      title: "Prepare your ID documents",
    },
    uaePButtonLabel: "استخدام بطاقة الإمارات العربية المتحدة",
    signSPA: "التحقق من هويتك",
    ensureEmailInUAEPLabel: "يرجى التأكد من أن البريد الإلكتروني الموجود على UAE Pass هو: ",
    verifyViaUAE: "التحقق عبر UAE PASS",
    uploadDocuments: "قم بتحميل المستندات الخاصة بك",
    continueUpload: "استمر في تحميل المستندات التالية:",
    UAEPassLoginFailed: "عذرًا، فشل التسجيل عبر بطاقة المرور الإماراتية. يرجى إعادة المحاولة أو اختيار الخيار الآخر.",
    UAEPassLoginEmailMismatch: " آسف. البريد الإلكتروني المستخدم لشراء العقار لا يتطابق مع البريد الإلكتروني المرتبط ببطاقة المرور الإماراتية الخاصة بك. يرجى تحديث عنوان البريد الإلكتروني أو متابعة تحميل المستندات الخاصة بك.",
    UAEPassLoginCancelled: "يبدو أنك قمت بإلغاء تسجيل الدخول إلى UAE Pass. يرجى إعادة المحاولة أو اختيار الخيار الآخر."
  },
  docusign: {
    updateFailed: "Docusign update failed. Please retry later.",
    retrievalFailed: "Docusign retrieval failed. Please retry later.",
  }

};